type NodeContentsVisited = {
  hasUserVisited: boolean
}

type NodeContentsCompleted = {
  hasUserCompleted: boolean
}

interface ModuleNodes {
  node: NodeContentsVisited | NodeContentsCompleted
}

interface ModuleContents {
  edges: ModuleNodes[]
}

interface ModulesType {
  contents: ModuleContents
  position: number
}

/**
 * This function finds the first uncomplete module index by checking if the user has visited/completed them.
 * Visited is for content that has no duration(Text, pdf etc.), Completed is otherwise (video, audio)
 *
 * @param modules This is and array of module nodes, based on @see CollectionContents_modules_edges_node
 * @returns the index of the first uncompleted module, stored in position. If no uncompleted module is found, returns -1.
 */
export const findFirstUncompletedModulePosition = (modules: ModulesType[]) => {
  for (const module of modules) {
    const contents = module.contents.edges.map((edge) => edge.node)
    if (
      contents.some(
        // Narrowing down ModuleNodes since not every node has hasUserVisited props and viceversa
        (content) =>
          'hasUserVisited' in content
            ? !content.hasUserVisited
            : !content.hasUserCompleted
      )
    ) {
      return module.position
    }
  }

  return -1
}
